import { type JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const postLostJob = async ({
  searchId,
  reason,
  customerType,
  sendEmail,
  name,
  email,
  customerId,
  extraInfo,
}: JsonDataItem) => {
  const { data } = await baseQuery('lost-job', {
    type: 'POST',
    body: {
      search_history_id: searchId,
      reason_id: reason,
      customer_type: customerType,
      send_email: sendEmail,
      customer_name: name,
      email,
      customer_id: customerId,
      extra_info: extraInfo,
    },
  });

  return data;
};
